<template>
  <div class="login-page">
    <div class="login-card">
      <div class="logo-area">
        <h1>碧湾信息</h1>
      </div>

      <div class="tab-bar">
        <div class="tab-item" :class="{active: loginType===0}" @click="switchTab(0)">验证码登录</div>
        <div class="tab-item" :class="{active: loginType===1}" @click="switchTab(1)">密码登录</div>
      </div>

      <div class="form-group">
        <div class="input-wrap">
          <input v-model="phoneNum" type="tel" maxlength="11" placeholder="请输入手机号" inputmode="numeric">
        </div>
      </div>

      <template v-if="loginType===0">
        <div v-if="!captchaPassed" class="captcha-box">
          <div class="captcha-header">
            <span class="captcha-tip">拖动滑块完成拼图</span>
            <div class="captcha-refresh-btn" @click="loadCaptcha">
              <span class="captcha-refresh-icon">↻</span>
              <span>换一张</span>
            </div>
          </div>
          <div class="captcha-imgs" ref="captchaArea" :style="{height: captchaH + 'px'}">
            <canvas ref="bgCanvas" class="bg-canvas" :style="{height: captchaH + 'px'}"></canvas>
            <canvas ref="pieceCanvas" class="piece-canvas"
              :style="{left: slideX + 'px'}"
              @mousedown="onDragStart"
              @touchstart.prevent="onTouchStart">
            </canvas>
            <div class="captcha-loading" v-if="captchaLoading">加载中…</div>
          </div>
          <div class="captcha-track-wrap" :class="{success: captchaPassed}">
            <div class="captcha-track">
              <div class="captcha-track-fill" :style="{width: fillW + 'px'}"></div>
            </div>
            <div class="captcha-handle" :class="{success: captchaPassed}"
              :style="{left: handleLeft + 'px'}"
              @mousedown="onHandleDragStart"
              @touchstart.prevent="onHandleTouchStart">
              <span class="captcha-handle-check">✓</span>
            </div>
          </div>
          <div class="captcha-status" :class="captchaStatusClass">{{captchaStatusMsg}}</div>
        </div>
        <div v-if="captchaPassed" class="captcha-passed-tip">
          <span>✓ 人机验证通过</span>
          <span @click="resetCaptcha" class="recaptcha-btn">重新验证</span>
        </div>

        <div class="form-group">
          <div class="input-wrap">
            <input v-model="code" type="text" maxlength="6" placeholder="4位短信验证码" inputmode="numeric">
            <div class="input-addon" :class="{disabled: !codeBtnState || !captchaPassed}" @click="getCode">
              {{ codeBtnText }}
            </div>
          </div>
        </div>
      </template>

      <template v-if="loginType===1">
        <div class="form-group">
          <div class="input-wrap">
            <input v-model="password" :type="passwordSee ? 'text' : 'password'" placeholder="请输入密码">
            <button class="eye-btn" @click="passwordSee=!passwordSee" type="button">
              <i class="el-icon-view" style="font-size:18px;"></i>
            </button>
          </div>
        </div>
      </template>

      <button class="login-btn" @click="doLogin">登 录</button>

      <div class="agreement-line">
        未注册手机验证后自动登录，登录即代表同意
        <span @click="showModal('agreement')">《用户协议》</span>
        <span @click="showModal('privacy')">《隐私政策》</span>
      </div>
    </div>

    <div class="modal-overlay" v-show="modalType==='agreement'" @click.self="closeModal">
      <div class="modal-box">
        <span class="modal-close" @click="closeModal">✕</span>
        <h2>碧湾用户服务协议</h2>
        <p>感谢选择碧湾为您提供服务！</p>
        <p>《碧湾用户服务协议》由杭州碧湾信息科技有限公司（以下简称为"碧湾"）和您签订。</p>
        <p>请悉知：碧湾App自2023年9月27号上线，至2023年10月31号为试运营阶段，供用户免费试用，不进行任何收费。后续正式运营期间开始收费，用户可自行决定购买与否。</p>
        <p>1、碧湾服务所涉及的相关权利归碧湾所有，包括但不限于行情系统、数据分析系统、网站资讯、手机短信、APP等。用户完成注册程序，即表示用户对本协议全部条款的确认和接纳。</p>
        <p>2、在接受碧湾服务前，用户首先得确认碧湾服务系通过移动互联网进行，用户得自行承担上网和服务相关的费用。</p>
        <p>3、为了维护用户的合法权益，用户需要提供真实合法、详尽准确的个人身份信息，并及时根据实际状况予以更新。</p>
        <p>4、用户注册成功后，将得到一个密码和账号，由用户自行更新、保管并承担全部责任。</p>
        <p>5、碧湾根据用户的注册信息对用户进行身份识别，以帮助用户处理诸如密码丢失、服务投诉等事项。</p>
        <p>6、凡是密码、账号正确或通过已授权登录方式而登录成功的，均被视为用户本人登录，由此造成的后果均由用户本人承担。</p>
        <p>7、碧湾依照国家法律法规的规定，合理审慎地保护用户的注册信息，不予公开、不向第三方提供。</p>
        <p>8、尊重用户个人隐私是碧湾的一项基本政策，详见《碧湾隐私政策》。</p>
        <p>22、如需联络碧湾，可拨打电话 +0571 8668 5367，或来函至杭州市滨江区江陵南路312号B幢。</p>
        <p>23、因履行本协议发生争议的，双方应友好协商，协商不成的，提交碧湾住所地有管辖权的法院裁决。</p>
      </div>
    </div>

    <div class="modal-overlay" v-show="modalType==='privacy'" @click.self="closeModal">
      <div class="modal-box">
        <span class="modal-close" @click="closeModal">✕</span>
        <h2>碧湾隐私政策</h2>
        <p style="text-align:right;font-size:13px;color:#888;">本版发布日期：2023年09月27日</p>
        <p><strong>一、声明</strong></p>
        <p>杭州碧湾信息技术有限公司（浙江省杭州市滨江区江陵南路312号B幢，联系方式：+0571 8668 5367）尊重并保护您的隐私。您通过计算机设备、移动终端或其他设备使用我们的服务时，我们会收集和使用您的相关信息。</p>
        <p><strong>二、收集和使用个人信息的适用范围</strong></p>
        <p>2.1 注册、登录：在您注册本应用帐号时，您根据本应用要求提供的个人注册信息，以及手机验证码登录所需的手机号码。</p>
        <p>2.2 搜索：您使用碧湾的搜索服务时，我们会收集您的搜索关键字信息、日志记录。</p>
        <p>2.3 运营与安全运行：为了保障软件与服务的安全运行，我们会收集您的硬件型号、操作系统版本号、IP地址、网络接入方式等信息。</p>
        <p><strong>三、信息使用</strong></p>
        <p>本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可。</p>
        <p><strong>七、信息安全</strong></p>
        <p>本应用账号均有安全保护功能，请妥善保管您的用户名及密码信息。</p>
        <p><strong>十一、注销账号</strong></p>
        <p>若您需要注销账号，请在App内点击【我的】—【个人信息】—【注销账户】按钮，提交注销申请并完成注销。</p>
        <p><strong>十二、联系我们</strong></p>
        <p>如有任何问题，请发送邮件到 info@beawan.com 与我们联系。</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sendRequestCompany } from '../../static/js/util';

const CANVAS_W = 280, CANVAS_H = 160, PIECE_W = 50;

export default {
  name: 'LoginPage',
  data() {
    return {
      loginType: 0,
      phoneNum: '',
      code: '',
      password: '',
      passwordSee: false,
      codeBtnState: true,
      codeBtnText: '获取验证码',
      modalType: '',
      captchaToken: '',
      captchaPassed: false,
      captchaLoading: false,
      captchaStatusMsg: '',
      captchaStatusClass: '',
      slideX: 0,
      bgImg: null,
      pieceImg: null,
      isDragging: false,
      dragStartClientX: 0,
      dragStartSlideX: 0,
      containerW: 280,
    }
  },
  computed: {
    scaledPieceW() {
      return Math.round(PIECE_W * this.containerW / CANVAS_W);
    },
    trackMax() {
      return Math.max(0, this.containerW - 40);
    },
    handleLeft() {
      return Math.max(0, Math.min(this.slideX, this.trackMax));
    },
    fillW() {
      return this.handleLeft + 20;
    },
    captchaH() {
      return Math.round(this.containerW * CANVAS_H / CANVAS_W);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.measureContainer();
      this.loadCaptcha();
      window.addEventListener('resize', this.measureContainer);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureContainer);
  },
  methods: {
    measureContainer() {
      const el = this.$refs.captchaArea;
      if (el) this.containerW = el.clientWidth || 280;
    },
    switchTab(type) {
      this.loginType = type;
      if (type === 0) {
        this.$nextTick(() => {
          this.measureContainer();
          if (!this.captchaPassed) this.loadCaptcha();
          else { this.drawBgOnCanvas(); this.drawPieceOnCanvas(); }
        });
      }
    },
    loadCaptcha() {
      this.slideX = 0;
      this.captchaPassed = false;
      this.captchaLoading = true;
      this.captchaStatusMsg = '';
      this.captchaStatusClass = '';
      axios.get('/beawanHome/smsController/captcha').then(res => {
        const d = res.data;
        this.captchaLoading = false;
        if (d.code !== 0) { this.captchaStatusMsg = '加载失败，请刷新重试'; return; }
        this.captchaToken = d.token;
        const bgI = new Image();
        bgI.onload = () => { this.bgImg = bgI; this.drawBgOnCanvas(); };
        bgI.src = d.bg;
        const piI = new Image();
        piI.onload = () => { this.pieceImg = piI; this.drawPieceOnCanvas(); };
        piI.src = d.piece;
      }).catch(() => {
        this.captchaLoading = false;
        this.captchaStatusMsg = '加载失败，请刷新重试';
      });
    },
    drawBgOnCanvas() {
      const c = this.$refs.bgCanvas;
      if (!c || !this.bgImg) return;
      const dpr = window.devicePixelRatio || 1;
      const cssW = this.containerW, cssH = this.captchaH;
      c.width = cssW * dpr; c.height = cssH * dpr;
      c.style.width = cssW + 'px'; c.style.height = cssH + 'px';
      const ctx = c.getContext('2d');
      ctx.scale(dpr, dpr);
      ctx.drawImage(this.bgImg, 0, 0, cssW, cssH);
    },
    drawPieceOnCanvas() {
      const c = this.$refs.pieceCanvas;
      if (!c || !this.pieceImg) return;
      const scale = this.containerW / CANVAS_W;
      const cssW = Math.round(PIECE_W * scale), cssH = this.captchaH;
      c.width = cssW; c.height = cssH;
      c.style.width = cssW + 'px'; c.style.height = cssH + 'px';
      c.getContext('2d').drawImage(this.pieceImg, 0, 0, cssW, cssH);
    },
    onHandleDragStart(e) {
      e.preventDefault();
      this.isDragging = true;
      this.dragStartClientX = e.clientX;
      this.dragStartSlideX = this.slideX;
      document.addEventListener('mousemove', this.onHandleDragMove);
      document.addEventListener('mouseup', this.onHandleDragEnd);
    },
    onHandleDragMove(e) {
      if (!this.isDragging) return;
      const dx = e.clientX - this.dragStartClientX;
      this.slideX = Math.max(0, Math.min(this.dragStartSlideX + dx, this.trackMax));
    },
    onHandleDragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onHandleDragMove);
      document.removeEventListener('mouseup', this.onHandleDragEnd);
      this.onRelease();
    },
    onHandleTouchStart(e) {
      const t = e.touches[0];
      this.isDragging = true;
      this.dragStartClientX = t.clientX;
      this.dragStartSlideX = this.slideX;
      document.addEventListener('touchmove', this.onHandleTouchMove, { passive: false });
      document.addEventListener('touchend', this.onHandleTouchEnd);
    },
    onHandleTouchMove(e) {
      e.preventDefault();
      if (!this.isDragging) return;
      const dx = e.touches[0].clientX - this.dragStartClientX;
      this.slideX = Math.max(0, Math.min(this.dragStartSlideX + dx, this.trackMax));
    },
    onHandleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.removeEventListener('touchmove', this.onHandleTouchMove);
      document.removeEventListener('touchend', this.onHandleTouchEnd);
      this.onRelease();
    },
    onDragStart(e) { this.onHandleDragStart(e); },
    onTouchStart(e) { this.onHandleTouchStart(e); },
    onRelease() {
      this.captchaStatusMsg = '验证中…';
      this.captchaStatusClass = '';
      const slideXServer = Math.round(this.slideX * CANVAS_W / this.containerW);
      axios.get('/beawanHome/smsController/verifyCaptcha', {
        params: { token: this.captchaToken, slideX: slideXServer }
      }).then(res => {
        if (res.data.code === 0) {
          this.captchaPassed = true;
          this.captchaStatusMsg = '';
        } else {
          this.captchaStatusMsg = res.data.msg || '未对齐，请重试';
          this.captchaStatusClass = 'err';
          setTimeout(() => { this.slideX = 0; this.captchaStatusMsg = ''; this.captchaStatusClass = ''; }, 800);
        }
      }).catch(() => {
        this.captchaStatusMsg = '网络异常，请重试';
        this.captchaStatusClass = 'err';
        setTimeout(() => { this.slideX = 0; this.captchaStatusMsg = ''; this.captchaStatusClass = ''; }, 800);
      });
    },
    resetCaptcha() {
      this.captchaPassed = false;
      this.slideX = 0;
      this.$nextTick(() => { this.measureContainer(); this.loadCaptcha(); });
    },
    getCode() {
      if (!this.codeBtnState) return;
      if (!this.captchaPassed) { this.$message.warning('请先完成滑块验证'); return; }
      if (!this.phoneNum) { this.$message.warning('手机号不能为空'); return; }
      if (!/^1[3-9]\d{9}$/.test(this.phoneNum)) { this.$message.error('手机号格式不正确'); return; }
      this.codeBtnState = false;
      this.codeBtnText = '发送中…';
      axios.get('/beawanHome/smsController/sendCode', {
        params: { phone: this.phoneNum, token: this.captchaToken }
      }).then(res => {
        if (res.data.code === 0) {
          this.$message.success('验证码已发送，请注意查收短信');
          let sec = 60;
          this.codeBtnText = sec + ' s';
          const timer = setInterval(() => {
            sec--;
            if (sec <= 0) {
              clearInterval(timer);
              this.codeBtnState = true;
              this.codeBtnText = '获取验证码';
              this.resetCaptcha();
            } else { this.codeBtnText = sec + ' s'; }
          }, 1000);
        } else {
          this.$message.error(res.data.msg || '发送失败');
          this.codeBtnState = true;
          this.codeBtnText = '获取验证码';
          this.resetCaptcha();
        }
      }).catch(() => {
        this.$message.error('服务器异常，请稍后重试');
        this.codeBtnState = true;
        this.codeBtnText = '获取验证码';
        this.resetCaptcha();
      });
    },
    doLogin() {
      if (this.loginType === 0) this.loginBySms();
      else this.loginByPassword();
    },
    loginBySms() {
      if (!this.phoneNum) { this.$message.warning('手机号不能为空'); return; }
      if (!this.code) { this.$message.warning('验证码不能为空'); return; }
      const url = '/user/loginByCode?phoneNumber=' + this.phoneNum + '&code=' + this.code;
      sendRequestCompany(url, 'get', null, null, (res) => {
        if (res.code === 0) this.handleLoginSuccess(res.data.tokenValue);
        else this.$message.error(res.msg || '登录失败');
      }, () => { this.$message.error('服务器异常'); });
    },
    loginByPassword() {
      if (!this.phoneNum) { this.$message.warning('手机号不能为空'); return; }
      if (!this.password) { this.$message.warning('密码不能为空'); return; }
      const url = '/user/loginByPassword?phoneNumber=' + this.phoneNum + '&password=' + this.password;
      sendRequestCompany(url, 'get', null, null, (res) => {
        if (res.code === 0) this.handleLoginSuccess(res.data.tokenValue);
        else this.$message.error(res.msg || '登录失败');
      }, () => { this.$message.error('服务器异常'); });
    },
    handleLoginSuccess(tokenValue) {
      localStorage.setItem('satoken', tokenValue);
      localStorage.setItem('satokenDate', new Date().toLocaleDateString());
      const exp = new Date(); exp.setDate(exp.getDate() + 30);
      document.cookie = `satoken=${tokenValue}; expires=${exp.toUTCString()}`;
      this.$message.success('登录成功');
      setTimeout(() => { window.location.href = '/beawanHome'; }, 1000);
    },
    showModal(type) { this.modalType = type; },
    closeModal() { this.modalType = ''; },
  }
}
</script>

<style scoped>
* { box-sizing: border-box; }

.login-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: linear-gradient(135deg, #e8f5e9 0%, #e3f2fd 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,.14), 0 2px 8px rgba(0,0,0,.08);
  width: 420px;
  max-width: 95vw;
  padding: 40px 40px 32px;
}

.logo-area {
  text-align: center;
  margin-bottom: 28px;
}
.logo-area h1 {
  font-size: 22px;
  font-weight: 700;
  color: #1a6c4a;
  margin-top: 8px;
}
.tab-bar {
  display: flex;
  border-bottom: 2px solid #eee;
  margin-bottom: 24px;
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 15px;
  color: #888;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all .2s;
}
.tab-item.active {
  color: #1a6c4a;
  border-bottom-color: #1a6c4a;
  font-weight: 600;
}

.form-group { margin-bottom: 14px; }

.input-wrap {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color .2s;
}
.input-wrap:focus-within { border-color: #1a6c4a; }

.input-wrap input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 12px 14px;
  font-size: 15px;
  outline: none;
  color: #333;
}
.input-wrap input::placeholder { color: #bbb; }

.input-addon {
  padding: 0 14px;
  font-size: 13px;
  color: #1a6c4a;
  cursor: pointer;
  white-space: nowrap;
  border-left: 1px solid #e0e0e0;
  height: 100%;
  display: flex;
  align-items: center;
  min-height: 44px;
}
.input-addon:hover { background: #f0faf5; }
.input-addon.disabled { color: #aaa; cursor: not-allowed; }

.eye-btn {
  background: none;
  border: none;
  padding: 0 14px;
  cursor: pointer;
  color: #aaa;
  font-size: 18px;
  min-height: 44px;
}

.captcha-box {
  background: #fff;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,.06);
}
.captcha-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.captcha-header span { font-size: 12px; color: #999; }
.captcha-tip { font-size: 13px !important; color: #555 !important; font-weight: 500; }
.captcha-refresh-btn {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  color: #aaa;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all .15s;
}
.captcha-refresh-btn:hover { color: #1a6c4a; background: #f0faf5; }
.captcha-refresh-icon {
  font-size: 14px;
  display: inline-block;
  transition: transform .3s;
}
.captcha-refresh-btn:hover .captcha-refresh-icon { transform: rotate(180deg); }

.captcha-imgs {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #e8e8e8;
  user-select: none;
}
.bg-canvas {
  display: block;
  width: 100%;
  pointer-events: none;
}
.piece-canvas {
  position: absolute;
  top: 0;
  cursor: grab;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,.4));
  transition: filter .15s;
  image-rendering: pixelated;
}
.piece-canvas:active { cursor: grabbing; }

.captcha-loading {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #888;
  border-radius: 8px;
}

.captcha-track-wrap {
  margin-top: 10px;
  position: relative;
  height: 40px;
}
.captcha-track {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 6px;
  transform: translateY(-50%);
  background: #ebebeb;
  border-radius: 3px;
  overflow: hidden;
}
.captcha-track-fill {
  height: 100%;
  background: linear-gradient(90deg, #b2dfcf, #1a6c4a);
  border-radius: 3px;
  transition: width .05s;
}
.captcha-track-wrap.success .captcha-track { background: #c8f0dc; }

.captcha-handle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #1a6c4a;
  box-shadow: 0 2px 8px rgba(26,108,74,.25);
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow .15s, border-color .15s, background .2s;
  user-select: none;
  touch-action: none;
}
.captcha-handle:hover { box-shadow: 0 4px 14px rgba(26,108,74,.4); }
.captcha-handle:active { cursor: grabbing; }
.captcha-handle.success { background: #1a6c4a; border-color: #1a6c4a; }
.captcha-handle-check {
  font-size: 16px;
  color: #fff;
  display: none;
  pointer-events: none;
}
.captcha-handle.success .captcha-handle-check { display: block; }

.captcha-status {
  font-size: 12px;
  margin-top: 6px;
  min-height: 16px;
  text-align: center;
}
.captcha-status.ok { color: #1a6c4a; }
.captcha-status.err { color: #e53935; }

.captcha-passed-tip {
  font-size: 13px;
  color: #1a6c4a;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f0faf5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.recaptcha-btn { color: #aaa; cursor: pointer; font-size: 12px; }

.login-btn {
  width: 100%;
  padding: 13px;
  background: #1a6c4a;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 8px;
  transition: background .2s, transform .1s;
  letter-spacing: 1px;
}
.login-btn:hover { background: #155a3c; }
.login-btn:active { transform: scale(.98); }

.agreement-line {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-top: 14px;
}
.agreement-line span { color: #1a6c4a; cursor: pointer; }
.agreement-line span:hover { text-decoration: underline; }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.6);
  z-index: 100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 40px 12px 60px;
}
.modal-box {
  background: #fff;
  border-radius: 10px;
  padding: 28px 24px;
  max-width: 760px;
  width: 100%;
  position: relative;
}
.modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 22px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}
.modal-close:hover { color: #333; }
.modal-box h2 { text-align: center; margin-bottom: 16px; font-size: 18px; }
.modal-box p { font-size: 14px; line-height: 1.7; margin-bottom: 10px; color: #444; }

@media (max-width: 480px) {
  .login-card { padding: 28px 20px 24px; }
  .logo-area h1 { font-size: 19px; }
  .modal-overlay { padding: 20px 8px 40px; }
  .modal-box { padding: 20px 14px; }
}
</style>
